import {Component, OnDestroy, OnInit} from '@angular/core';
import {AlertService} from '../../../../services/alert-service.service';

@Component({
  selector: 'app-alert-bar',
  templateUrl: './alert-bar.component.html',
  styleUrls: ['./alert-bar.component.scss']
})
export class AlertBarComponent implements OnInit, OnDestroy {
  variant: any = 'success';
  position: any = 'bottom-left';
  message: any = 'This is a message';
  time :any = 3000

  timeout: any;

  public isOpen = false;

  private subscription$: any = null;

  constructor(
    private alertService: AlertService
  ) {

    this.subscription$ = alertService.toggleAlert.subscribe(value => {
      this.variant = value.variant;
      this.position = value.position;
      this.message = value.message;
      this.isOpen = value.open;
      this.time = value.time ? value.time : 3000;
      clearTimeout(this.timeout);
      if (value.open) {
        this.timeout = setTimeout(() => {
          this.isOpen = false;
        }, this.time);
      }

    });

  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

}
